import script from "./traffic-detail-drawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./traffic-detail-drawer.vue?vue&type=script&setup=true&lang=ts"

import "./traffic-detail-drawer.vue?vue&type=style&index=0&id=8ebd0102&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ebd0102"]])

export default __exports__